var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 543,
    viewBox: "0 0 1440 543",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_160_1965)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_160_1965)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-34.8676 206.614V-119.067L1326.23 -218C1533.14 -6.43494 1822.82 411.825 1326.23 392.342C705.49 367.99 925.334 355.052 420.986 256.119C83.7856 189.973 -19.4769 192.573 -34.8676 206.614V215.784C-37.5229 212.576 -37.8927 209.374 -34.8676 206.614Z",
    fill: "url(#paint0_linear_160_1965)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_160_1965)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M364.026 -96.0413C430.025 -93.828 505.177 -114.051 555.17 -97.0479C605.611 -79.8921 574.754 -48.2987 580.951 -22.2615C588.367 8.89476 638.201 41.6966 594.428 67.8849C546.693 96.4439 448.648 115.781 364.026 107.521C284.092 99.7177 277.382 56.9658 225.636 31.8843C184.404 11.8989 111.738 2.69919 96.2695 -22.2615C77.4385 -52.6476 71.7072 -93.0663 137.043 -111.07C202.265 -129.041 284.544 -98.7067 364.026 -96.0413Z",
    fill: "#B3B4F7"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_160_1965)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1223.25 116.99C1311.75 118.361 1362.03 77.1421 1450.35 79.3025C1530.42 81.2612 1585.54 105.962 1622.48 126.756C1658.74 147.171 1656.01 170.941 1653.95 193.921C1651.92 216.423 1666.67 243.603 1610.59 259.086C1551.9 275.293 1444.95 258.696 1375.56 270.792C1304.34 283.206 1306.22 327.084 1223.25 326.607C1139.4 326.126 1147.56 280.994 1074.37 269.063C999.468 256.853 859.731 283.868 822.688 261.309C783.979 237.736 929.739 219.31 950.979 193.921C965.168 176.96 917.128 160.571 921.526 143.161C927.784 118.387 900.06 79.1299 981.765 72.043C1074.9 63.965 1126.22 115.487 1223.25 116.99Z",
    fill: "#B3B4F7"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_160_1965",
    x: -187,
    y: -368,
    width: 1992,
    height: 911,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 75,
    result: "effect1_foregroundBlur_160_1965"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_160_1965",
    x: -137,
    y: -318,
    width: 1837.42,
    height: 811,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    result: "effect1_foregroundBlur_160_1965"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_160_1965",
    x: 3.65234,
    y: -196.729,
    width: 688.57,
    height: 386.171,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 40,
    result: "effect1_foregroundBlur_160_1965"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_160_1965",
    x: 736.182,
    y: -8.81592,
    width: 998.818,
    height: 415.427,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 40,
    result: "effect1_foregroundBlur_160_1965"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_160_1965",
    x1: 781.71,
    y1: -218,
    x2: 781.71,
    y2: 393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8081E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4345D8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.75443102e411a9b5213ff45de557485b.svg";
export { ForwardRef as ReactComponent };